import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const invalidCellClassName = "!border-red-400 !text-red-400";
export const invalidTextClassName = "!text-red-400";
